import PropTypes from "prop-types";
import { connect } from "react-redux";
import styled from "styled-components";

import actions from "@/actions";

import GroupList from "./GroupList";
import GroupListItem from "./GroupListItem";
import Icon from "./Icon";
import ListItemAdd from "./ListItemAdd";

const GeometryIcon = styled(Icon)`
    padding-left: 5px;
`;

const GeometryItem = styled(GroupListItem)`
    cursor: unset;
`;

const GeometryTitle = styled.div`
    flex: 1;
`;

const GroupDetail = ({
    group,
    geometries,
    setHoveredGroupGeometry,
    setEditingGroupGeometry,
    changeMode,
    deleteGroupGeometry,
}) => {
    const clearHoveredGeometry = () => setHoveredGroupGeometry(null);

    const editGeometry = (geometry) => {
        clearHoveredGeometry();
        changeMode("group-edit");
        setEditingGroupGeometry(geometry);
    };

    const deleteGeometry = (geometry) => {
        clearHoveredGeometry();
        deleteGroupGeometry(geometry.id);
    };

    return (
        <GroupList>
            <ListItemAdd onAdd={() => changeMode("group", { group })} />

            {(geometries[group.displayID] ?? []).map((geometry, i) => (
                <GeometryItem
                    key={geometry.id}
                    onMouseEnter={() => setHoveredGroupGeometry(geometry.id)}
                    onMouseLeave={clearHoveredGeometry}
                >
                    <GeometryTitle>Geometry #{i + 1}</GeometryTitle>
                    <GeometryIcon
                        className="fa fa-pencil geometry-item"
                        onClick={() => editGeometry(geometry)}
                    />
                    <GeometryIcon
                        className="fa fa-trash geometry-item"
                        onClick={() => deleteGeometry(geometry)}
                    />
                </GeometryItem>
            ))}
        </GroupList>
    );
};

GroupDetail.propTypes = {
    group: PropTypes.object.isRequired,
    geometries: PropTypes.object.isRequired,
    setHoveredGroupGeometry: PropTypes.func.isRequired,
    setEditingGroupGeometry: PropTypes.func.isRequired,
    changeMode: PropTypes.func.isRequired,
    deleteGroupGeometry: PropTypes.func.isRequired,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {
    setHoveredGroupGeometry: actions.map.general.setHoveredGroupGeometry,
    setEditingGroupGeometry: actions.map.general.setEditingGroupGeometry,
    changeMode: actions.map.general.changeMode,
    deleteGroupGeometry: actions.map.values.global.deleteGroupGeometry,
};

export default connect(mapStateToProps, mapDispatchToProps)(GroupDetail);
